var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-logos"},_vm._l((_vm.logos),function(logo,index){return _c('div',{key:index,staticClass:"logo-item"},[_c('img',{attrs:{"src":logo.url,"alt":`Partner ${index + 1}`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }